// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"h6","cusMtdicon":"h6"};